/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const HotelBedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Hotel Bed',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35.2 22H.8L6 14h24ZM0 24v5a1 1 0 0 0 1 1h3v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V30h24v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V30h3a1 1 0 0 0 1-1v-5Zm8-13a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1h4v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1h2V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5h2Z"
    />
  </svg>`;
};
